import { StateCreator } from "zustand";
import { learningFolderType } from "../../types/learning-material";
export interface FilterState {
  keyword: string;
  page: number;
  size: number;
  tab: "1" | "2";
  ownerId?: number;
  updaterId?: number;
  enterpriseUuid?: string;
  updatedDate?: [string, string];
  folderInfo?: learningFolderType;
  set: <K extends keyof FilterState>(k: K, v: FilterState[K]) => void;
  reset: () => void;
}
const DEFAULT: Omit<FilterState, "set" | "reset"> = {
  keyword: "",
  page: 1,
  size: 10,
  tab: "1",
};

export const createFilterSlice: StateCreator<FilterState> = (set) => ({
  ...DEFAULT,
  set: (k, v) => set({ [k]: v } as any),
  reset: () => set(DEFAULT),
});
